import { render, staticRenderFns } from "./ProjectManagerInformation.vue?vue&type=template&id=03779c06"
import script from "./ProjectManagerInformation.vue?vue&type=script&lang=ts"
export * from "./ProjectManagerInformation.vue?vue&type=script&lang=ts"
import style0 from "./ProjectManagerInformation.vue?vue&type=style&index=0&id=03779c06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports